import styled from "styled-components";

export const InfoItemData = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const InfoLabel = styled.div`
  color: ${(props) => props.theme.colors.primary100};
  font-size: 1.4rem;
  font-weight: 400;
  white-space: nowrap;
`;

export const InfoDataBox = styled.div`
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.4rem;
  font-weight: 700;
  text-align: right;
`;
